import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { ImageBlockInterface } from '~/types/AppData/PageBuilder/ImageBlockInterface';
import Image from '~/components/Shared/Image/Image';
import { getImagePathAndExtension } from '~/utilities/getImagePathAndExtension';
import { getImageCroppingObject } from '~/utilities/getImageCroppingObject';

export default component$<ImageBlockInterface['props']>(
  ({ image }): JSX.Element => {
    const { imageURL, altText } = image;

    if (!imageURL) return null;

    const cropping = getImageCroppingObject(imageURL);
    const { path, extension } = getImagePathAndExtension(imageURL);

    return (
      <Image
        alt={altText}
        path={path}
        fileExtension={extension}
        cropping={cropping}
        imageWidths={{ small: 719, medium: 1000, large: 1440 }}
        loading='lazy'
        imageClass='max-w-[1440px] w-full'
        wrapperClass='flex justify-center mb-6'
      />
    );
  }
);
